import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { requestJson } from '../lib/api';
import { normalizeMenuConfig } from '../lib/menuConfig';

function findMenuEntry(menuConfig, pathname) {
  const item = menuConfig.items.find((menuItem) => menuItem.path === pathname);
  const group = item ? menuConfig.groups.find((menuGroup) => menuGroup.id === item.groupId) : null;
  return { item, group };
}

export function useMenuPage(pathOverride = '') {
  const location = useLocation();
  const pathname = pathOverride || location.pathname;
  const [menuConfig, setMenuConfig] = useState(() => normalizeMenuConfig());

  const loadMenuConfig = useCallback(async () => {
    try {
      const payload = await requestJson('/settings/MENU');
      setMenuConfig(normalizeMenuConfig(payload.value));
    } catch (_error) {
      setMenuConfig(normalizeMenuConfig());
    }
  }, []);

  useEffect(() => {
    loadMenuConfig();
    window.addEventListener('opticdev:menu-config-updated', loadMenuConfig);
    return () => window.removeEventListener('opticdev:menu-config-updated', loadMenuConfig);
  }, [loadMenuConfig]);

  return useMemo(() => {
    const { item, group } = findMenuEntry(menuConfig, pathname);
    return {
      item,
      group,
      pageTitle: item?.label || 'Accueil',
      sectionTitle: group?.label || 'Dashboard',
      breadcrumbs: ['Dashboard', group?.label, item?.label].filter(Boolean),
    };
  }, [menuConfig, pathname]);
}
